import React, { useEffect , useRef} from 'react'
import Typed from 'typed.js';
import "./home.css"

function Home() {
  const el = useRef(null);
  const typed = useRef(null);
  useEffect(() => {
    const options = {
      strings: [
        "React",
        "Node",
        "Firebase",
        "Css",
        "E muito Esforço"
      ],
      typeSpeed: 100,
      backSpeed: 150,
      loop: true,
    };
    typed.current = new Typed(el.current,options)
    return () => {
      typed.current.destroy();
    }
  },[])
  return (
    <div className='home'>
        <span>Olá 👋! Eu sou </span>
        <h1>Matheus Santos</h1>
        <h3>Front End dev</h3>
        <p>Eu sou baiano desenvolvedor frontEnd.
            Sou apaixonado em construir coisas para web usando <span className='span-animated' ref={el}></span>.
        </p>
        
    </div>
  )
}

export default Home;